import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/account/')({
  beforeLoad: ({ params }) => {
    throw redirect({ params, to: '/$workspaceSlug/account/profile' })
  },
})
